import { Navigate, useNavigate, Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

const ProtectedRouteForDashboard = () => {
  const [isUserInDashboard, setIsUserInDashboard] = useState(true);
  
  useEffect(() => {
    const checkAuth = async () => {
      await axios
        .post(`${process.env.REACT_APP_BASE_URL}/is-customer-logged-in`, {}, {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          let isLoggedIn = Boolean(res.data.flag);
          setIsUserInDashboard(isLoggedIn);
        })
        .catch((err) => {
          localStorage.removeItem("token");
        });
    };
    checkAuth();
  }, []);

  let isSafe = true;
  var acc = localStorage.getItem("token");
  if (acc === null) {
    isSafe = false;
  }

  if (isUserInDashboard && isSafe) {
    return <Outlet />;
  } else {
    localStorage.removeItem("token");
    return <Navigate to="/" />;
  }
};

export default ProtectedRouteForDashboard;
